import { GroupsConstants } from '../GroupsConstants';
import { GroupsUtils } from '../GroupsUtils';
import { GroupsActions } from '../GroupsActions';
import { GroupStatusesEnum } from '../models/GroupStatuses';
// Modals
import { DeleteGroupMemberAlertController } from './modals/DeleteGroupMemberAlertController';
import DeleteGroupMemberAlertView from './modals/DeleteGroupMemberAlertView.html';
const nameElementIdPrefix = 'new-member-name-';
const numberElementIdPrefix = 'new-member-number-';
export class GroupDetailsController {
    static $inject = ['$stateParams', '$state', 'LoadingService', 'BlipToastService', '$translate', 'UsersService', 'application', 'ApplicationService2', 'GroupsService', '$timeout', 'ModalService', 'GroupsSegmentService', 'MEDIA_PROFILE_FOR_AVATARS'];
    constructor($stateParams, $state, LoadingService, BlipToastService, $translate, UsersService, application, ApplicationService2, GroupsService, $timeout, ModalService, GroupsSegmentService, MEDIA_PROFILE_FOR_AVATARS) {
        'ngInject';
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.LoadingService = LoadingService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.UsersService = UsersService;
        this.application = application;
        this.ApplicationService2 = ApplicationService2;
        this.GroupsService = GroupsService;
        this.$timeout = $timeout;
        this.ModalService = ModalService;
        this.GroupsSegmentService = GroupsSegmentService;
        this.MEDIA_PROFILE_FOR_AVATARS = MEDIA_PROFILE_FOR_AVATARS;
        this.selectedAll = false;
        this.hasAnySelected = false;
        this.canUpdateGroup = true;
        this.newMembers = [];
        this.maxNumberOfMembers = 8;
        this.addMembersFailedText = '';
        this.deleteMembersFailedText = '';
        this.backClick = () => {
            this.$state.go(GroupsConstants.GROUPS_STATE);
        };
        this.getUploadElement = () => {
            return document.getElementById('group-avatar-uploader').shadowRoot.querySelector('.upload__input');
        };
        this.handleGroupPictureChange = async (event) => {
            this.fileUploaded(event.detail.value[0]);
        };
        this.handleSelectAll = async () => {
            await this.$timeout(() => {
                this.selectedAll = !this.selectedAll;
                this.group.members = this.group.members
                    .map((member) => {
                    const element = this.getMemberCheckboxElement(member.identity);
                    const checked = !member.canDelete ? false : this.selectedAll;
                    element.checked = checked;
                    return {
                        ...member,
                        selected: checked,
                    };
                });
            });
            this.setHasAnySelected();
        };
        this.handleSelectMember = async (memberIndex) => {
            const member = this.group.members[memberIndex];
            await this.$timeout(() => {
                const element = this.getMemberCheckboxElement(member.identity);
                const checked = !member.canDelete ? false : !member.selected;
                element.checked = checked;
                member.selected = checked;
            });
            this.setHasAnySelected();
        };
        this.handleOpenDeleteMembersModal = async (singleMember) => {
            const selectedMembers = this.group.members.filter((member) => member.selected);
            const members = singleMember ? [singleMember] : selectedMembers;
            await this.ModalService.showModal({
                template: DeleteGroupMemberAlertView,
                controller: DeleteGroupMemberAlertController,
                controllerAs: '$ctrl',
                inputs: {
                    members,
                    groupName: this.group.name,
                    deleteMembers: this.handleDeleteMembers.bind(this),
                    trackGiveUp: this.trackDeleteMembersGiveUp.bind(this),
                },
            });
        };
        this.handleClickAddMember = async () => {
            if (this.newMembers.length === 0) {
                this.addNewMembers();
            }
        };
        this.handleCancelAddNewMembers = async () => {
            this.$timeout(() => {
                this.newMembers = [];
            });
            const nameElement = document.getElementById(`${nameElementIdPrefix}0`);
            const numberElement = document.getElementById(`${numberElementIdPrefix}0`);
            nameElement.value = '';
            numberElement.value = '';
        };
        this.handleClickAddMoreMembers = async () => {
            this.addNewMembers();
        };
        this.removeNewMember = async (spliceIndex) => {
            const realIndex = spliceIndex + 1;
            this.$timeout(() => {
                this.newMembers.splice(realIndex, 1);
                this.newMembers.forEach((member, index) => {
                    const nameElement = document.getElementById(`${nameElementIdPrefix}${index}`);
                    const numberElement = document.getElementById(`${numberElementIdPrefix}${index}`);
                    nameElement.value = member.name;
                    numberElement.value = member.phoneNumber;
                });
                const addMoreMembersButtonElement = this.getAddMoreMembersButtonElement();
                addMoreMembersButtonElement.disabled = this.isAddMoreMembersButtonDisabled();
            });
        };
        this.handleChangeMemberNumber = async (event) => {
            const index = this.getElementIndex(event.target.id);
            this.$timeout(() => {
                const [memberNumberIsValid, phoneNumberOldValue] = this.validateNewMemberPhoneNumberPattern(event);
                if (memberNumberIsValid) {
                    this.newMembers[index].phoneNumber = event.target.value;
                }
                else {
                    event.target.value = phoneNumberOldValue;
                }
            });
        };
        this.handleChangeMemberName = async (event) => {
            const index = this.getElementIndex(event.target.id);
            this.$timeout(() => {
                this.newMembers[index].name = event.target.value;
            });
        };
        this.handleAddMembers = async () => {
            const filteredMembers = this.newMembers?.filter((member) => member.phoneNumber != undefined && member.phoneNumber != '');
            if (!filteredMembers || filteredMembers.length === 0) {
                return;
            }
            try {
                this.LoadingService.startLoading();
                this.GroupsSegmentService.trackGroupAddMembersRequest(this.application, filteredMembers, this.groupId);
                const result = await this.GroupsService.manageGroupMembers(this.groupId, filteredMembers, true);
                if (result) {
                    this.BlipToastService.show('success', {
                        msg: await this.$translate('groups.messages.success.addMember.default.msg'),
                    });
                    this.handleCancelAddNewMembers();
                }
                else {
                    this.BlipToastService.show('danger', {
                        msg: await this.$translate('groups.messages.errors.addMember.default.msg'),
                    });
                }
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('groups.messages.errors.addMember.default.msg'),
                });
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
        this.canAddAnyMembers = () => {
            return this.group.members.length < this.maxNumberOfMembers;
        };
        this.newMembersLimit = () => {
            return this.maxNumberOfMembers - this.group.members.length;
        };
        this.setGroupDetailsAndStatuses = async () => {
            await this.setGroupAndMembers();
            await this.delay(1000);
            await this.getMembersStatusAndSetBehaviours();
        };
        this.setGroupAndMembers = async () => {
            await this.$timeout(async () => {
                this.group = (await this.UsersService.getUser(this.application, this.groupIdentity));
                const groupMembersResponse = await this.GroupsService.getGroupMembers(this.groupId);
                this.group.members = groupMembersResponse?.members || [];
                if (groupMembersResponse.error) {
                    this.BlipToastService.show('danger', {
                        msg: groupMembersResponse.error.toString() || '',
                    });
                }
                if (this.group.members.length >= this.maxNumberOfMembers) {
                    const addMembersButtonElement = document.getElementById('add-members-button');
                    addMembersButtonElement.disabled = true;
                }
            });
        };
        this.getMembersStatusAndSetBehaviours = async () => {
            const groupsStatuses = await this.getMembersStatuses();
            await this.setMembersMessages(groupsStatuses);
            this.setGroupUpdateBehaviour(groupsStatuses?.Update);
            this.$timeout(() => {
                this.group.members = this.group.members.map((member) => {
                    const canDelete = this.canMemberBeDeleted(member, groupsStatuses?.DeleteMembers);
                    try {
                        const element = this.getMemberCheckboxElement(member.identity);
                        element.disabled = !canDelete;
                    }
                    catch (_) {
                        console.error('Error trying to get member checkbox element');
                    }
                    return {
                        ...member,
                        selected: false,
                        canDelete,
                    };
                });
            });
        };
        this.setGroupUpdateBehaviour = (updateStatus) => {
            if (!updateStatus || updateStatus.length === 0) {
                return;
            }
            const updateGroupStatus = updateStatus.find((update) => update.GroupId === this.groupId);
            if (!updateGroupStatus) {
                return;
            }
            this.$timeout(() => {
                this.canUpdateGroup = updateGroupStatus.Status != GroupStatusesEnum.PENDING;
            });
        };
        this.setMembersMessages = async (groupsStatuses) => {
            if (!groupsStatuses) {
                return;
            }
            await this.setAddMembersFailedMessages(groupsStatuses.AddMembers);
            await this.setDeleteMembersFailedMessages(groupsStatuses.DeleteMembers);
        };
        this.setAddMembersFailedMessages = async (statuses) => {
            if (!statuses || statuses.length === 0) {
                return;
            }
            const faileds = statuses.filter((addMember) => addMember.Status === GroupStatusesEnum.FAILED);
            if (faileds && faileds.length > 0) {
                const failedBaseMessageSingular = await this.$translate('groups.statuses.addMember.failed.singular');
                const failedBaseMessagePlural = await this.$translate('groups.statuses.addMember.failed.plural');
                const failedBaseMessageGroupName = await this.$translate('groups.statuses.addMember.failed.groupName');
                const lastMemberConnection = await this.$translate('groups.statuses.addMember.failed.lastConnection');
                this.$timeout(() => {
                    this.addMembersFailedText = this.mountMembersBannerMessage(failedBaseMessageSingular, failedBaseMessagePlural, failedBaseMessageGroupName, lastMemberConnection, faileds);
                });
            }
        };
        this.setDeleteMembersFailedMessages = async (statuses) => {
            if (!statuses || statuses.length === 0) {
                return;
            }
            const faileds = statuses.filter((deleteMember) => deleteMember.Status === GroupStatusesEnum.FAILED);
            if (faileds && faileds.length > 0) {
                const failedBaseMessageSingular = await this.$translate('groups.statuses.deleteMember.failed.singular');
                const failedBaseMessagePlural = await this.$translate('groups.statuses.deleteMember.failed.plural');
                const failedBaseMessageGroupName = await this.$translate('groups.statuses.deleteMember.failed.groupName');
                const lastMemberConnection = await this.$translate('groups.statuses.deleteMember.failed.lastConnection');
                this.$timeout(() => {
                    this.deleteMembersFailedText = this.mountMembersBannerMessage(failedBaseMessageSingular, failedBaseMessagePlural, failedBaseMessageGroupName, lastMemberConnection, faileds);
                });
            }
        };
        this.mountMembersBannerMessage = (singular, plural, groupBase, lastConnection, statuses) => {
            let members = '';
            if (statuses.length > 1) {
                statuses.forEach((failed, index) => {
                    if (index === statuses.length - 1) {
                        members += `${lastConnection} ${failed.MemberPhoneNumber}`;
                        members = members.replace(`, ${lastConnection}`, ` ${lastConnection}`);
                        return;
                    }
                    members += `${failed.MemberPhoneNumber}, `;
                });
            }
            else {
                members = statuses[0].MemberPhoneNumber;
            }
            return (statuses.length === 1 ? singular : plural)
                + members
                + groupBase
                + this.group.name;
        };
        this.getMembersStatuses = async () => {
            try {
                const actions = [GroupsActions.UPDATE, GroupsActions.ADD_MEMBERS, GroupsActions.DELETE_MEMBERS];
                const groupsStatuses = await this.GroupsService.getGroupsStatuses(actions, this.groupId);
                return groupsStatuses;
            }
            catch (_) {
                return undefined;
            }
        };
        this.canMemberBeDeleted = (member, deleteMemberActions) => {
            if (!deleteMemberActions) {
                return true;
            }
            const deleteMemberAction = deleteMemberActions.find(deleteAction => deleteAction.MemberPhoneNumber === member.phoneNumber);
            return deleteMemberAction?.Status != GroupStatusesEnum.PENDING;
        };
        this.isAddMoreMembersButtonDisabled = () => {
            return this.group.members.length + this.newMembers.length >= this.maxNumberOfMembers;
        };
        this.getAddMoreMembersButtonElement = () => {
            return document.getElementById('add-more-members-button');
        };
        this.getElementIndex = (elementId) => {
            const idSplit = elementId.split('-');
            const index = Number.parseInt(idSplit[idSplit.length - 1]);
            return index;
        };
        this.addNewMembers = async () => {
            this.$timeout(() => {
                this.newMembers.push({
                    name: '',
                    phoneNumber: '',
                    identity: '',
                });
                const addMoreMembersButtonElement = this.getAddMoreMembersButtonElement();
                addMoreMembersButtonElement.disabled = this.isAddMoreMembersButtonDisabled();
            });
        };
        this.handleDeleteMembers = async (members) => {
            try {
                if (!members || members.length === 0) {
                    return;
                }
                this.LoadingService.startLoading();
                this.GroupsSegmentService.trackGroupRemoveMembersRequest(this.application, members, this.groupId);
                const result = await this.GroupsService.manageGroupMembers(this.groupId, members, false);
                if (!result) {
                    this.BlipToastService.show('danger', {
                        msg: await this.$translate('groups.messages.errors.deleteMember.default.msg'),
                    });
                    return;
                }
                this.BlipToastService.show('success', {
                    msg: await this.$translate('groups.messages.success.deleteMember.default.msg'),
                });
                this.resetSelectAllMembersCheckbox();
                this.blockMembersCheckboxes(members);
                this.setHasAnySelected();
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('groups.messages.errors.deleteMember.default.msg'),
                });
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
        this.resetSelectAllMembersCheckbox = () => {
            try {
                const selectAllElement = document.getElementById('select-all-members-checkbox');
                selectAllElement.checked = false;
                this.$timeout(() => {
                    this.selectedAll = false;
                });
            }
            catch (_) {
                console.info('Error trying to get select all members checkbox element');
            }
        };
        this.blockMembersCheckboxes = (members) => {
            members.forEach((member) => {
                const memberItem = this.group.members.find((groupMember) => groupMember.identity === member.identity);
                memberItem.canDelete = false;
                memberItem.selected = false;
                try {
                    const element = this.getMemberCheckboxElement(member.identity);
                    element.disabled = true;
                    element.checked = false;
                }
                catch (_) {
                    console.error('Error trying to get member checkbox element');
                }
            });
        };
        this.getMemberCheckboxElement = (memberIdentity) => {
            return document.getElementById(`member-checkbox-${memberIdentity}-id`);
        };
        this.validateFileType = (filename) => {
            return ['jpg'].includes(`${filename.split('.').pop()}`);
        };
        this.fileUploaded = async (file) => {
            let updateGroupRequest;
            try {
                if (!this.canUpdateGroup) {
                    return;
                }
                if (!file || !this.validateFileType(file.name)) {
                    throw 'error';
                }
                this.LoadingService.startLoading();
                const photoUri = await this.ApplicationService2.uploadFile(file, { type: 'image/jpg', profile: this.MEDIA_PROFILE_FOR_AVATARS });
                updateGroupRequest = {
                    profilePictureUri: photoUri,
                };
                this.GroupsSegmentService.trackGroupUpdateImageRequest(this.application, updateGroupRequest, this.groupId);
                const updateGroupResponse = await this.GroupsService.updateGroup(this.groupId, updateGroupRequest);
                if (!updateGroupResponse) {
                    this.BlipToastService.show('danger', {
                        msg: await this.$translate('groups.messages.errors.updateGroup.default.msg'),
                    });
                    return;
                }
                this.BlipToastService.show('success', {
                    msg: await this.$translate('groups.messages.success.updateGroup.default.msg'),
                });
                this.$timeout(() => {
                    this.canUpdateGroup = false;
                });
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('groups.messages.errors.updateGroup.default.msg'),
                });
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
    }
    async $onInit() {
        try {
            this.LoadingService.startLoading();
            if (this.$stateParams.id) {
                this.groupId = this.$stateParams.id;
                this.groupIdentity = GroupsUtils.addGroupIdentitySuffix(this.groupId);
                await this.setGroupDetailsAndStatuses();
            }
        }
        catch (error) {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('groups.messages.errors.default.msg'),
            });
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    validateNewMemberPhoneNumberPattern(event) {
        const newMemberPhoneNumberPatternAttribute = event.target.getAttribute('pattern') || '';
        const newMemberPhoneNumberPatternRegex = new RegExp(newMemberPhoneNumberPatternAttribute);
        if (newMemberPhoneNumberPatternRegex.test(event.target.value)) {
            return [true, ''];
        }
        else {
            const phoneNumberOldValue = event.target.value.split('').filter(char => newMemberPhoneNumberPatternRegex.test(char)).join('');
            return [false, phoneNumberOldValue];
        }
    }
    async delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    async setHasAnySelected() {
        this.$timeout(() => {
            this.hasAnySelected = this.group.members.some((member) => member.selected);
        });
    }
    async trackDeleteMembersGiveUp(members) {
        this.GroupsSegmentService.trackGroupMembersRemovalGiveUp(this.application, members, this.groupId);
    }
}
GroupDetailsController.$inject = ['$stateParams', '$state', 'LoadingService', 'BlipToastService', '$translate', 'UsersService', 'application', 'ApplicationService2', 'GroupsService', '$timeout', 'ModalService', 'GroupsSegmentService', 'MEDIA_PROFILE_FOR_AVATARS'];
